export const SUMMARY_DETAILS = [
  { label: "Number enrolled", key: "estEnrollment", unit: "" },
  { label: "Net Revenue", key: "estNetRevenue", unit: "currency" },
  {
    label: "Total Institutional Aid",
    key: "estInstitutionalAid",
    unit: "currency",
  },
  { label: "Total Discount", key: "estDiscountRate", unit: "percent" },
];
export const MODEL_DETAILS = [
  "Model name",
  "Author",
  "Last updated",
  "Aid results",
];
export const NAV_BAR_ITEMS = ["Non-Modeled Aid Results", "Admit Adjustments"];
